export const enum FieldEditorQa {
    Dialog = 'field-editor',
}
